import { render, staticRenderFns } from "./im-information.vue?vue&type=template&id=03541f98"
import script from "./im-information.vue?vue&type=script&lang=js"
export * from "./im-information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03541f98')) {
      api.createRecord('03541f98', component.options)
    } else {
      api.reload('03541f98', component.options)
    }
    module.hot.accept("./im-information.vue?vue&type=template&id=03541f98", function () {
      api.rerender('03541f98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/im-layout/js/component/im-information.vue"
export default component.exports